export default __webpack_public_path__ + "static/media/fondo_inversion_registro.bd24d44a.png";